import { wemAPIService } from "../../services/wem.service";
import { WEM } from "./actionsTypes";
import { apiStart, apiError, apiSuccess } from "./apiActions";

export const wemActions = {
  getWemList,
  postRequestQuote
};

export function getWemList(data: any) {
  return async (dispatch: any) => {
    dispatch(apiStart(WEM.GET_WEM_FETCHING));
    try {
      const response = await wemAPIService.getWemList(data);
      dispatch(apiSuccess(WEM.GET_WEM_SUCCESS, response));
      return response || [];
    } catch (error) {
      dispatch(apiError(WEM.GET_WEM_ERROR, error));
      return error;
    }
  };
}

export function getFiltersData() {
  return async (dispatch: any) => {
    dispatch(apiStart(WEM.GET_WEM_FILTERS_FETCHING));
    try {
      const response = await wemAPIService.getFiltersData();
      dispatch(apiSuccess(WEM.GET_WEM_FILTERS_SUCCESS, response));
      return response || [];
    } catch (error) {
      dispatch(apiError(WEM.GET_WEM_FILTERS_ERROR, error));
      return error;
    }
  };
}

export function postRequestQuote(data: any) {
  return async (dispatch: any) => {
    dispatch(apiStart(WEM.POST_REQUEST_QUOTE_FETCHING));
    try {
      const response = await wemAPIService.postRequestQuote(data);
      dispatch(apiSuccess(WEM.POST_REQUEST_QUOTE_SUCCESS, response));
      return response || [];
    } catch (error) {
      dispatch(apiError(WEM.POST_REQUEST_QUOTE_ERROR, error));
      return error;
    }
  };
}